// Powers the "Today's My Returns" quick view. A return's scheduledDate is an ISO instant; "today"
// for a preparer at a desk is a STAFF-INTERACTIVE question (fleet filter contract §9.3), which
// resolves in America/New_York, not UTC -- a return scheduled at 21:30 ET is still "today" to the
// preparer looking at it even though the UTC calendar date has already rolled to tomorrow.
//
// Deliberately NOT date-fns' isToday() (that reads the BROWSER's local zone, which is wrong for a
// staff member travelling, and makes the same click mean different things on different machines).

const BUSINESS_TIME_ZONE = 'America/New_York';

function ymdIn(date: Date, timeZone: string): string {
  // en-CA formats as YYYY-MM-DD directly, so this is a string compare, not a Date reconstruction.
  return new Intl.DateTimeFormat('en-CA', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).format(date);
}

/**
 * True when `dateStr` falls on the same calendar day as `now`, both read in `timeZone`.
 * Returns false (never throws) for a missing/unparseable date -- a return with no scheduledDate
 * simply doesn't show under "Today", which is correct: there is nothing to say it's today's.
 */
export function isScheduledToday(
  dateStr: string | undefined | null,
  now: Date = new Date(),
  timeZone: string = BUSINESS_TIME_ZONE
): boolean {
  if (!dateStr) return false;
  const parsed = new Date(dateStr);
  if (Number.isNaN(parsed.getTime())) return false;
  return ymdIn(parsed, timeZone) === ymdIn(now, timeZone);
}
